var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-inner"},[_c('Accordion',{attrs:{"v-if":_vm.block.accordion.accordion_items,"data":_vm.block.accordion.accordion_items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }